import { Component, OnInit, Input } from '@angular/core';


@Component({
    selector: 'ixs-label',
    templateUrl: 'label.component.html',
    styleUrls: ['label.component.css']
})

export class LabelComponent implements OnInit {
    @Input() label: string;
    @Input() width: string = 'auto';

    ngOnInit() {
    }
}


// WEBPACK FOOTER //
// ./src/app/components/label/label.component.ts